import gql from 'graphql-tag';
import { userQueryFields } from './common.queries';
import { buildPaginationQueryParams } from './utils';

const fundQueryFields = `
  id
  indigoEquityContribution
  indigoAssetPurchase
  indigoCashConstitution
  indigoEquityContributionAdjustment
  indigoFundCashEquivalent
  fundEquityContribution
  fundAssetPurchase
  fundCashConstitution
  fundEquityContributionAdjustment
  assignmentAmount
  variation
`;

const cessionGroupInfo = `
  id
  cessionDate
  totalContractValue
  status
  isCurrentCession
  createdAt
  fundInfo {
    ${fundQueryFields}
  }
  agFinancingProcesses {
    id
    collateralType
    grower {
      id
      name
    }
    campaign {
      id
      name
    }
    orderInfo {
      opportunities {
        id
        contractValue
      }
    }
    phase4 {
      id
      status
      assignedToCreditAt
      sentToFundBy {
        ${userQueryFields}
      }
      sentToFundAt
      sentToFundNotes
      receivedByFundBy {
        ${userQueryFields}
      }
      receivedByFundAt
      receivedByFundNotes
      sentToManagerBy {
        ${userQueryFields}
      }
      sentToManagerAt
      sentToManagerNotes
      deniedBy {
        ${userQueryFields}
      }
      deniedAt
      deniedNotes
      submittedBy {
        ${userQueryFields}
      }
      submittedAt
      submittedNotes
      postedToFund
    }
  }
`;

export const getAgGroupList = gql`
query getAgGroupList(
  $pagination: AGFPagination!
  $filters: AGFGCustomFilters
  $sort: AGFSort
) {
  getAgGroupList(pagination: $pagination, filters: $filters, sort: $sort) {
    ${buildPaginationQueryParams(cessionGroupInfo)}
  }
}
`;

export const getCessionGroupById = gql`
  query getAgGroupById($agGroupId: Int!) {
    getAgGroupById(agGroupId: $agGroupId) {
      ${cessionGroupInfo}
    }
  }
`;

export const removeAgFinanceFromCessionGroup = gql`
  mutation removeAgFinanceFromCessionGroup($agFinancingId: ID!) {
    removeAgFinanceFromCessionGroup(agFinancingId: $agFinancingId) {
      ${cessionGroupInfo}
    }
  }
`;

export const changeCessionGroupStatus = gql`
  mutation changeCessionGroupStatus($agGroupId: Int!, $status: AgFinancingPhase4Status!, $notes: String, $isResending: Boolean) {
    changeCessionGroupStatus(agGroupId: $agGroupId, status: $status, notes: $notes, isResending: $isResending) {
      ${cessionGroupInfo}
    }
  }
`;

export const addAgFinanceToCurrentCessionGroup = gql`
  mutation addAgFinanceToCurrentCessionGroup($agFinancingId: ID!, $cessionNumber: Int) {
    addAgFinanceToCurrentCessionGroup(agFinancingId: $agFinancingId, cessionNumber: $cessionNumber) {
      id
      agFinancingProcesses {
        id
        agGroup {
          id
          cessionDate
          totalContractValue
          status
          isCurrentCession
          createdAt
        }
      }
    }
  }
`;

export const upsertFundInfo = gql`
  mutation upsertFundInfo($agGroupId: Int!, $fundInfo: AgFundInfoInput!) {
    upsertFundInfo(agGroupId: $agGroupId, fundInfo: $fundInfo) {
      id
      status
      fundInfo {
        ${fundQueryFields}
      }
    }
  }
`;

export const upsertCessionGroupId = gql`
  mutation upsertCessionGroupId($currentNumber: Int!, $newNumber: Int!) {
    upsertCessionGroupId(currentNumber: $currentNumber, newNumber: $newNumber) {
      id
      status
    }
  }
`;
